import { USER_TYPE } from "@mozioinc/query";
import { useQuery } from "@tanstack/react-query";
import { usersQuery } from "../utils/query";
import { getAccessToken } from "../utils/token";

export const useUserData = () => {
  const isSignedIn = !!getAccessToken();
  const { data: user, isLoading } = useQuery({
    queryKey: ["myUser", isSignedIn],
    queryFn: usersQuery.getMyUser,
    enabled: isSignedIn,
  });
  const isTravelAgent = user?.userType === USER_TYPE.TRAVEL_AGENT;
  return { user, isLoading, isTravelAgent, isSignedIn };
};
